<template>
  <div class="p-3">
    <b-row>
      <b-col class="header_exercise">
        <b-row>
          <b-col class="col-12 col-sm-6 d-flex align-items-center">
            <div class="float-left">
              <b v-text="'لیست تمرین'" />
              <b
                v-if="showTotals && totalRows"
                class="badge badge-pill badge-primary fontSize-15 ml-1"
                v-text="totalRows"
              />
            </div>
          </b-col>
          <b-col class="col-12 col-sm-6">
            <button
              v-if="filterCatch && Object.values(paramsPage).length"
              type="button"
              class="btn btn-danger mx-2 position-relative float-right"
              @click="deleteFilterCacheResource"
              v-b-tooltip.hover
              :title="`پاک کردن فیلتر`"
            >
              <mdicon
                name="filter-remove-outline"
                size="24"
                class="cursor_pointer"
              />
            </button>
            <button
              type="button"
              class="btn float-right btn-lightgray ml-2 position-relative"
              v-if="filterheaders.length > 0"
              @click="showFilter"
            >
              <i class="fa fa-filter"></i>
            </button>
            <b-button
              class="btn-lightgray float-right ml-2"
              @click="addItem"
              v-if="buttons && buttons.includes('add')"
              v-b-tooltip.hover
            >
              <i class="fa fa-plus"></i>
            </b-button>
            <b-button
              class="btn-lightgray float-right ml-2"
              v-b-tooltip.hover
              title="به‌روز رسانی لیست"
              @click="!loadingItem && fillTable()"
            >
              <i class="fa fa-retweet fa-lg" />
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <LoadingSpinner :loading="loadingItem" />
    <b-row v-if="!loadingItem" class="justify-content-start">
      <div class="advance_filter" v-show="filter">
        <b-overlay :show="loadingItem" rounded="sm">
          <advanceFilter
            ref="advanceFilter"
            :headers="filterheaders"
            @getFilterItems="getFilterItems"
            @getFilterDate="getFilterDate"
            @closeAdvanceFilter="showFilter"
          />
        </b-overlay>
      </div>
      <b-col v-if="items.length" cols="12">
        <b-row v-for="(item, key) in items" :key="key" class="my-2">
          <b-col class>
            <b-card class="card_exercise">
              <div slot="header">
                <b-row>
                  <div class="col-12 col-md-6">
                    <strong>{{
                      pathOr(null, ["id"], item) +
                      "- " +
                      pathOr(null, ["name"], item)
                    }}</strong>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="d-flex justify-content-end">
                      <div
                        class="dynamicButtonGenerated"
                        v-for="(button, index) in availableButtons()"
                        :key="index"
                      >
                        <div
                          class="ml-3 dynamic-buttons"
                          @click="button.click(item)"
                        >
                          <span
                            class="cursor-pointer"
                            v-b-tooltip.hover
                            :title="button.text"
                          >
                            <i :class="button.iconFont" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-row>
              </div>
              <b-row>
                <!-- exercise header -->
                <b-col cols="8" class>
                  <b-row v-if="item.category">
                    <b-col>
                      <strong>{{
                        pathOr(null, ["category", "caption"], item)
                      }}</strong>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="text-align: justify">
                      <p v-text="pathOr(null, ['description'], item)" />
                    </b-col>
                  </b-row>
                </b-col>
                <!-- exercise details -->
                <b-col cols="4">
                  <b-row>
                    <b-col>
                      <div
                        v-if="
                          item.exercise_details && item.exercise_details.length
                        "
                        class="p-1 exercise-details my-1"
                      >
                        <b-row class="text-right">
                          <b-col class="m-1">
                            <span class="badge total-duration">{{
                              `${pathOr(0, ["duration"], item)} ${$lang.mins}`
                            }}</span>
                            <hr />
                          </b-col>
                        </b-row>

                        <template
                          v-for="(
                            exercise_detail, index
                          ) in item.exercise_details"
                        >
                          <b-row :key="index">
                            <b-col>
                              <div
                                class="float-left m-1"
                                v-text="
                                  `${pathOr(
                                    null,
                                    ['id'],
                                    exercise_detail
                                  )}- ${pathOr(
                                    null,
                                    ['caption'],
                                    exercise_detail
                                  )}`
                                "
                              />
                              <div class="float-right m-1">
                                <span
                                  class="badge algorithm-duration"
                                  v-text="
                                    `${pathOr(
                                      0,
                                      ['duration'],
                                      exercise_detail
                                    )} ${$lang.mins}`
                                  "
                                />
                              </div>
                            </b-col>
                          </b-row>
                        </template>
                      </div>
                      <b-row v-if="item.type && 'caption' in item.type">
                        <b-col class="exercise-type">
                          <i
                            class="fa fa-circle"
                            v-b-tooltip.hover
                            :title="$lang.type"
                          ></i>
                          {{ pathOr("", ["type", "caption"], item) }}
                        </b-col>
                      </b-row>
                      <b-row v-if="item.category && 'caption' in item.category">
                        <b-col>
                          <i
                            class="fa fa-circle"
                            v-b-tooltip.hover
                            :title="$lang.category"
                          ></i>
                          {{ pathOr("", ["category", "caption"], item) }}
                        </b-col>
                      </b-row>
                      <b-row v-if="item.level && 'caption' in item.level">
                        <b-col>
                          <i
                            class="fa fa-circle"
                            v-b-tooltip.hover
                            :title="$lang.level"
                          ></i>
                          {{ pathOr("", ["level", "caption"], item) }}
                        </b-col>
                      </b-row>
                      <b-row
                        v-if="
                          item.work_environment &&
                          'caption' in item.work_environment
                        "
                      >
                        <b-col>
                          <i
                            class="fa fa-circle"
                            v-b-tooltip.hover
                            :title="$lang.workEnvironment"
                          ></i>
                          {{
                            pathOr("", ["work_environment", "caption"], item)
                          }}
                        </b-col>
                      </b-row>

                      <b-row
                        v-if="
                          item.business_function &&
                          'caption' in item.business_function
                        "
                      >
                        <b-col>
                          <i
                            class="fa fa-circle"
                            v-b-tooltip.hover
                            :title="$lang.business_function"
                          ></i>
                          {{
                            pathOr("", ["business_function", "caption"], item)
                          }}
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <hr />
              <b-row
                v-if="item.competencies && item.competencies.length"
                class="mb-2"
              >
                <div class="ml-3">
                  <strong>{{ $lang.competencies }}</strong>
                </div>
                <template>
                  <div class="ml-3">
                    <template v-for="(competency, index) in item.competencies">
                      <span :key="index" class="float-left">
                        <i
                          class="fa fa-circle mr-1"
                          :style="getStyle(competency.reference)"
                          v-b-tooltip.hover
                          :title="
                            pathOr('', ['reference', 'caption'], competency)
                          "
                        ></i>
                        <strong class="badge competency-tag mr-3">{{
                          pathOr(null, ["id"], competency) +
                          "- " +
                          pathOr(null, ["caption"], competency)
                        }}</strong>
                      </span>
                    </template>
                  </div>
                </template>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <paganationSearch
          allowPaginate
          :total="totalRows"
          :total_pages="total_pages"
          :perPage="per_page"
          v-model="page"
          @input="paging"
        />
      </b-col>

      <b-col :class="`text-center ${classData} mt-2`" v-else>
        <h4 v-if="!loadingItem">{{ noData }}</h4>
      </b-col>
    </b-row>
    <confirm
      :title="modalTitle"
      :description="message"
      v-model="removemodal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="confirmedRemoveItem"
      @cancel="notConfirmedRemoveItem"
    ></confirm>

    <confirm
      :title="modalTitleCopy"
      :description="messageCopy"
      v-model="copyModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="confirmedCopy"
      @cancel="notConfirmCopy"
    ></confirm>

    <b-modal
      no-close-on-backdrop
      title
      v-model="addModal"
      hide-footer
      hide-header
      header-bg-variant="success"
      content-class="border-success"
      v-on:modal-end-up="handleAddModal"
      size="md"
      @hidden="hiddenAddModal"
    >
      <addExercise isModal @modal-end-up="handleAddModal"></addExercise>
    </b-modal>
  </div>
</template>

<script>
import paganationSearch from "@/components/base/paganationSearch";
import advanceFilter from "@/components/base/advanceFilter";
import confirm from "@/components/base/confirm";
import addExercise from "./addExercise";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";

export default {
  name: "exercise-card",
  components: {
    advanceFilter,
    confirm,
    addExercise,
    paganationSearch,
    LoadingSpinner,
  },
  props: {
    classData: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      filterCatch: true,
      showTotals: true,
      addModal: false,
      modalTitle: "",
      message: "",
      noData: "",
      removingItem: null,
      removemodal: false,
      total_pages: 0,
      permissions: [],
      buttons: [],
      loadScroll: false,
      showSomeBtn: false,
      permission: [],
      loadingItem: false,
      items: [],
      filterItems: [],
      filterheaders: [],
      inputSearch: "",
      width: 800,
      columns: [],
      viewCount: 10,
      page: 1,
      url: this.$config.api_url + this.$config.kanoon.exercise,
      filterUrl: "",
      defaultButtons: [
        {
          id: "7",
          text: this.$lang.search.clone_tooltip,
          name: "clone", //کپی
          iconFont: "fa fa-clone fa-lg text-secondary ",
          click: this.cloneExercise,
          AllowPermissions: ["admin"],
        },
        {
          id: "1",
          name: "design", // طراحی
          iconFont: "fa fa-plus fa-lg  text-success ",
          text: this.$lang.design_exercise_tooltip,
          AllowPermissions: ["admin", "edit"],
          click: this.designExercise,
        },
        {
          id: "2",
          name: "edit", // ویرایش
          iconFont: "fa fa-edit fa-lg  text-success ",
          text: this.$lang.search.edit_tooltip,
          AllowPermissions: ["admin", "edit"],
          click: this.modify,
        },
        {
          id: "3",
          name: "delete", //حذف
          text: this.$lang.search.remove_tooltip,
          iconFont: "fas fa-times  fa-lg text-danger ",
          AllowPermissions: ["admin"],
          click: this.removing,
        },

        {
          id: "4",
          name: "view", //نمایش
          text: this.$lang.show,
          iconFont: "fa fa-eye  fa-lg  text-success",
          AllowPermissions: ["view"],
          click: this.modify,
        },
      ],
      filter: false,
      totalRows: 0,
      per_page: 0,
      modalTitleCopy: null,
      messageCopy: null,
      copyModal: false,
      copyItem: {},
      paramsPage: {},
    };
  },
  created() {
    this.fillTable();
  },
  methods: {
    pathOr,
    paging(page) {
      this.paramsPage["page"] = page;
      this.getItems();
    },
    getFilterDate(key, type, value_from, value_to) {
      if (value_from) {
        this.paramsPage[key] = [type, value_from];
      } else if (value_to && value_from) {
        this.paramsPage[key] = [type, value_from, value_to];
      } else {
        delete this.paramsPage[key];
      }
      this.paramsPage["page"] = 1;
      this.getItems();
    },
    getFilterItems(value, key) {
      if (
        (typeof value == "string" || typeof value == "number") &&
        value !== ""
      ) {
        this.paramsPage[key] = value;
      } else if (typeof value == "object" && value.length > 0) {
        this.paramsPage[key] = value;
      } else {
        delete this.paramsPage[key];
      }
      this.paramsPage["page"] = 1;
      this.getItems();
    },
    async deleteFilterCacheResource() {
      try {
        const resource = this.getCatchFilterResource();
        const url =
          this.$config.api_url + this.$config.kanoon.filter_cache_resource;
        let params = {
          resource: resource,
        };
        const response = await this.$httpService.delete(url, params);
        this.$notify.success(response.data.message);
        this.paramsPage = {};
        this.getItems();
      } catch (error) {
        this.$generateError(error);
      }
    },
    getCatchFilterResource() {
      let url = this.url;
      const resource = url
        .split(`${this.$config.api_url}`)
        .filter(function (el) {
          return el != "";
        })[0]
        .split("?")[0];

      return resource ? resource : null;
    },
    async getFilterCacheResource() {
      try {
        const resource = this.getCatchFilterResource();
        const url =
          this.$config.api_url + this.$config.kanoon.filter_cache_resource;
        let prms = {
          resource: resource,
        };
        const response = await this.$httpService.get(url, prms);
        let data = response.data.data;
        let params = data.query_params;

        for (const key in params) {
          if (params.hasOwnProperty.call(params, key)) {
            const element = params[key];
            this.paramsPage[key] = element;
          }
        }
      } catch (error) {
        this.$generateError(error);
      }
    },
    async fillTable() {
      if (this.filterCatch) {
        let params = await this.getFilterCacheResource();
        for (const key in params) {
          if (params.hasOwnProperty.call(params, key)) {
            const element = params[key];
            this.paramsPage[key] = element;
          }
        }
      } else {
        this.paramsPage["page"] = 1;
        this.paramsPage["per_page"] = this.defaultViewCount;
      }
      await this.getItems();
      return true;
    },
    cloneExercise(item) {
      this.copyItem = item;
      this.copyModal = true;
      (this.messageCopy = this.$lang.are_you_sure_copy),
        (this.modalTitleCopy = this.$lang.search.clone_tooltip);
    },

    async confirmedCopy() {
      try {
        let url =
          this.$config.api_url +
          this.$config.kanoon.exercise_duplicate.replace(
            "{0}",
            this.copyItem.id
          );
        const response = await this.$httpService.post(url);
        this.$notify.success(response.data.message);
        this.getFirstPageItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.notConfirmCopy();
      }
    },
    notConfirmCopy() {
      this.removingItem = null;
      this.message = "";
      this.copyModal = false;
    },
    getStyle(ref) {
      return {
        // width: "13px",
        // content: "",

        // backgroundColor: ref.color,
        // height: "100%",
        // display: "inline-block",
        color: pathOr(null, ["color"], ref),
        // border: "7px solid " + ref.color,
        // paddingTop: "1px",
        verticalAlign: "middle",
        // borderLeft: "0px",
        // borderRight: "0px",
        // height: "18px",
        // borderTopLeftRadius: 0,
        // borderBottomLeftRadius: 0,
      };
    },
    showFilter() {
      this.filter = !this.filter;
    },
    getFirstPageItems() {
      this.page = 1;
      this.loadingItem = true;
      this.loadItems();
    },
    loadItems() {
      //  this.loadingItem = true;
      return this.getItems()
        .then((items) => {
          this.items = [...this.items, ...items];
          return true;
        })
        .finally(() => (this.loadingItem = false));
    },
    getFilteredItems() {
      // زمانی که فیلتر را می زنید این متد صذا زده می شود
      this.page = 1;
      this.loadingItem = true;
      this.getItems()
        .then((items) => {
          this.items = [...items];
        })
        .finally(() => (this.loadingItem = false));
    },
    getItems(updateConfig = true) {
      this.loadingItem = true;
      this.columns = [];
      let url = this.url;
      let params = {
        ...this.paramsPage,
      };

      return this.$httpService
        .get(url, params)
        .then((response) => {
          // this.buttons = response.data.buttons;
          this.permissions = response.data.permissions;
          this.genatatePermistionButton(response.data.permissions);

          if (!this.filterheaders.length > 0) {
            this.filterheaders = response.data.filters.map((x) => {
              return {
                key_filter_caption: x.key_filter_caption,
                key_filter_name: x.key_filter_name,
                key_service: x.key_service,
                open: x.open,
                type: x.type,
                loader: !x.open,
              };
            });
            let data = [...this.filterheaders];
            for (const item of data) {
              if (item.open) {
                this.getFilter(item);
              }
            }
          }

          if (response.data.data && "result" in response.data.data) {
            this.total_pages = response.data.data.total_pages;
            this.per_page = response.data.data.per_page;
            let items = response.data.data.result;
            if (items.length == 0) {
              this.items = [];
              this.noData = this.$lang.noData;
              return true;
            }

            this.items = items;
            this.totalRows = response.data.data.total;
            return items;
          } else {
            return [];
          }
        })
        .catch((err) => {
          this.$generateError(err);
          throw err;
        })
        .finally(() => {
          /* در صورتی که جستجو چیزی برنگردانده باشد
                             مقدار فیلتر ستون‌ها خالی است و پس از جستجو کردن و مقدار داشتن، باید دوباره از اول فیلتر ستون‌ها پر شود
                            */
          if (this.columns && this.columns.length)
            if (updateConfig)
              // در صورتی که نیاز به آپدیت کانفیگ باشد، آپدیت شود
              this.updateConfig();

          this.$emit("change", this.items);
          this.loadingItem = false;
        });
    },
    async getFilter(key) {
      try {
        if (
          !this.filterItems[key.key_filter_name] &&
          key.key_service !== "search_txt"
        ) {
          const data = await this.$httpService.get(
            this.$config.api_url +
              this.$config.kanoon.filterData.replace(
                "{key_filter_name}",
                key.key_filter_name
              )
          );
          let items = data.data.data;
          if (items.length > 0 && items) {
            this.filterItems[key.key_filter_name] = items;
          }
        }
      } catch (error) {
        // check error here
      }
    },

    availableButtons() {
      // create buttons

      return this.defaultButtons
        .filter((button) => {
          // compare button permission and user permissions
          let ok = Object.values(this.permissions).filter((x) =>
            button.AllowPermissions.includes(x)
          );
          // compare keys button has and defult button dosent have
          return ok.length > 0;
        })
        .map((but) => {
          let temp = Object.assign({}, but); // clone
          let permission = this.defaultButtons.find((x) => x.name == but.name);
          return {
            ...permission,
            ...temp,
          };
        });
    },
    modify(item) {
      // this.$router.push(+item.id);
      this.$router.push({
        name: "editExercise",
        params: {
          id: item.id,
        },
      });
    },
    removing(item) {
      this.removingItem = item;
      this.message = this.$lang.are_you_sure_to_remove_item.replace(
        "{item}",
        item.name
      );
      this.modalTitle = this.$lang.remove_item;
      this.removemodal = true;
    },
    confirmedRemoveItem() {
      if (this.removingItem) {
        this.loadingItem = true;
        this.remove_item(this.removingItem).finally(() => {
          this.removingItem = null;
          this.message = "";
          this.getItems()
            .then((items) => {
              this.items = items;
            })
            .finally(() => {
              this.loadingItem = false;
              this.notConfirmedRemoveItem();
            });
        });
      }
    },
    notConfirmedRemoveItem() {
      this.removingItem = null;
      this.message = "";
      this.removemodal = false;
    },

    remove_item(item) {
      return this.$httpService
        .delete(this.url + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
    addItem() {
      this.addModal = true;
    },
    handleAddModal() {
      this.addModal = !this.addModal;
      this.hiddenAddModal();
    },
    hiddenAddModal() {
      this.loadingItem = true;
      // this.page=1;
      // this.getItems().then(items => {
      //     this.items = items}).finally(() => (this.loadingItem = false));
      this.getFilteredItems();
    },
    designExercise(item) {
      this.$router.push({
        name: "exerciseDesign",
        params: {
          id: item.id,
        },
      });
    },
    genatatePermistionButton(permitions) {
      if (permitions) {
        if (permitions.includes("admin")) {
          this.buttons = ["add", "delete", "edit", "enable", "view"];
        }
        if (permitions.includes("edit")) {
          this.buttons = ["edit", "enable"];
        }
        if (permitions.includes("view")) {
          this.buttons = ["view"];
        }
      } else {
        this.buttons = [];
      }
    },
  },
};
</script>

<style>
.header_exercise {
  background: #f0f3f5;
  padding: 10px;
  border: 1px solid lightgray;
  margin: 0 15px 5px;
}

.card_exercise {
  margin-bottom: 5px;
}

.exercise-details {
  border-radius: 5px 20px 5px;
  background: #cae6fc;
}

.competency-tag {
  background: #4040c8;
  /* background: black; */
  /* color: white; */
  color: white;
  font-weight: 300;
  font-size: 12px;
}

.reference-tag {
  background: #bd40c8;
  color: white;
  font-weight: 300;
  font-size: 12px;
}

.exercise-type {
  color: #4040c8;
}

.algorithm-duration {
  /* color: #4040c8; */

  background: #4040c8;
  color: white;
  font-weight: 400;
  font-size: 12px;
}

.total-duration {
  /* color: #bd40c8; */
  background: #bd40c8;
  color: white;
  font-weight: 400;
  font-size: 12px;
}

.border-competency {
  /* background: #bd40c8; */
  border-right: 2px solid #bd40c8;
}
.advance_filter {
  height: 100vh;
  left: -5px;
  top: 47px;
}
</style>
